import React, { useState } from "react";
import env from "../../env/env.json";

const InfoPopupCards = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupVisibleInfo, setPopupVisibleInfo] = useState(false);
  const email = env.email_ville;

  const togglePopup = () => {
    setPopupVisible(!popupVisible);
    setPopupVisibleInfo(false);
  };
  const togglePopupInfo = () => {
    setPopupVisibleInfo(!popupVisibleInfo);
    setPopupVisible(false);
  };

  const redirectToCGU = () => {
    window.open(env.CGU);
  };

  const redirectToRGPD = () => {
    window.open(env.RGPD);
  };

  return (
    <>
      <div
        className="popup-cgu d-flex justify-content-center align-items-center"
        onClick={redirectToCGU}
      >
        <p className="text-light fw-bold m-0">CGU</p>
      </div>
      <div
        className="popup-rgpd d-flex justify-content-center align-items-center"
        onClick={redirectToRGPD}
      >
        <p className="text-light fw-bold m-0">RGPD</p>
      </div>
      <div className="popup-question" onClick={togglePopup}>
        <i className="fas fa-envelope"></i>
      </div>
      {popupVisible && (
        <div
          className="card text-bg-light mb-3 shadow"
          style={{ maxWidth: "20rem", zIndex: 1000 }}
        >
          <div className="card-header d-flex justify-content-between fw-bold">
            Besoin d'aide ?
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={togglePopup}
            ></button>
          </div>
          <div className="card-body">
            <h6 className="card-title">Contacts:</h6>
            <p className="card-text m-0">
              Pour toute demande en lien avec l’instruction de votre dossier,
              vous pouvez nous contacter à l’adresse :<br />
              <i className="fas fa-envelope">&nbsp;</i>&nbsp;
              <a href={"mailto:" + email} target="_blank" rel="noreferrer">
                {email}
              </a>
            </p>
            <p className="mt-3">
              Pour tout problème technique, vous pouvez contacter notre support
              via le chat accessible juste en dessous.
              {/* <a
                href="https://tally.so/r/me7adx"
                target="_blank"
                rel="noreferrer"
              >
                formulaire de support.
              </a> */}
            </p>
          </div>
        </div>
      )}
      <div className="popup-info" onClick={togglePopupInfo}>
        <i className="fas fa-info"></i>
      </div>
      {popupVisibleInfo && (
        <div
          className="card text-bg-light mb-3 shadow card-info"
          style={{ maxWidth: "20rem", zIndex: 1000 }}
        >
          <div className="card-header d-flex justify-content-between fw-bold">
            Information:
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={togglePopupInfo}
            ></button>
          </div>
          <div className="card-body">
            <p className="card-text m-0">
              La procédure autorise l'ajout de pièces complémentaires à votre
              dossier en une seule fois. Il vous est donc recommandé de fournir
              tous les documents nécessaires en une seule opération.
              Assurez-vous de rassembler et d'envoyer l'intégralité des
              documents demandés.
              {/* Si vous rencontrez des difficultés pour
              transmettre vos documents, vous pouvez remplir notre{" "}
              <a
                href="https://tally.so/r/me7adx"
                target="_blank"
                rel="noreferrer"
              >
                formulaire de support.
              </a> */}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default InfoPopupCards;
